import { InjectionToken } from '@angular/core';
import { Configuration } from '@azure/msal-browser';

export interface AuthConfig {
  msal: Configuration,
  protectedResourceMap: Map<string, string[]>;
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
